import { useT } from "../i18n/LocaleProvider";
import { failureView, type Failure } from "../system/failure";
import { Notice } from "./Notice";

/**
 * A read that did not come back: a calm grey line for a permission limit, an error with "Try again" for a
 * fault (system/failure.ts decides which). `fallback` is the screen's own sentence, already translated.
 */
export function LoadFailed({ failure, fallback, onRetry }: { failure: Failure; fallback: string; onRetry: () => void }) {
  const { t } = useT();
  const view = failureView(failure, fallback, t("You do not have access to this."));
  return (
    <div className="stack load-failed">
      <Notice tone={view.tone}>{view.sentence}</Notice>
      {view.retry ? (
        <div className="row">
          <button className="btn btn-secondary" type="button" onClick={onRetry}>
            {t("Try again")}
          </button>
        </div>
      ) : null}
    </div>
  );
}
